import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileGenerateAccessUrlMutationAtom = createMutationAtomFactory(
  'files.generateAccessUrl',
  (params: { fileIds: string[]; expirySeconds?: number }) => ({
    filesGenerateFileAccessURL: {
      __args: {
        fileIds: params.fileIds,
        expirySeconds: params.expirySeconds || 3600,
      },
      results: {
        fileId: true,
        url: true,
        expiresAt: true,
        error: true,
      },
    },
  }),
  {
    showLoadingOverlay: false,
  },
);
